import { useNavigationPathname } from '@/hooks/useNavigationPathname'
import { PortfolioNavigation } from './PortfolioNavigation'
import { siteConfig } from '@/config/site'

export const SiteNavigation = () => {
  const pathname = useNavigationPathname().replace(/\/+$/, '') || '/'
  const isArticle = pathname.startsWith('/blog/') || pathname.startsWith('/case-studies/')
  const isDesign = pathname.startsWith('/design/')
  const isWork = pathname === '/work' || pathname === '/blog' || pathname === '/design' || pathname === '/designv2' || isArticle || isDesign
  return <PortfolioNavigation section={isWork ? 'work' : 'home'} backHref={isArticle || isDesign ? siteConfig.workIndexUrl : undefined} backLabel="Back to Work" />
}
